import FallbackLoader from 'components/FallbackLoader';
import Layout from 'components/Layout';
import { ComponentType, FC, Suspense } from 'react';
import { Route, RouteComponentProps, RouteProps } from 'react-router-dom';

import styles from './RouteContainer.module.scss';
import AuthorizedModule from './components';

interface Props<T> extends RouteProps {
  component: ComponentType<RouteComponentProps<T>> | ComponentType<T>;
  isMobile?: boolean;
  withMobileWellSelect?: boolean;
}

const RouteContainer: FC<Props<Record<string, unknown>>> = ({
  component: Component,
  isMobile,
  withMobileWellSelect,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => (
      <AuthorizedModule>
        <Layout isMobile={isMobile} withMobileWellSelect={withMobileWellSelect}>
          {/* INFO: The main tag is used in a query selector in useScrollToTop hook */}
          <main className={styles.container}>
            <Suspense fallback={<FallbackLoader />}>
              <Component {...props} isMobile={isMobile} />
            </Suspense>
          </main>
        </Layout>
      </AuthorizedModule>
    )}
  />
);

export default RouteContainer;
